import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "antd";

import { Header, Nav, HamburgerMenu } from "./components";

import {
  loginUserCheck,
  logoutUser,
  brandFetchPromo,
  brandUpdatePromo,
} from "../redux/actions";

class AdminProductPromotion extends Component {
  constructor() {
    super();
    this.state = {
      img: "",
      img2: "",
      img3: "",
      img4: "",
      photo: "",
      photo2: "",
      photo3: "",
      photo4: "",
      toggleMenu: false,
    };
  }

  componentWillMount() {
    this.props.loginUserCheck();
    this.props.brandFetchPromo();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.promoBrand) {
      // console.log(nextProps.promoBrand)
      let img = "", img2 = "", img3 = "", img4 = ""
      nextProps.promoBrand.forEach(item => {
        if (item.rank === 1) img = item.url
        else if (item.rank === 2) img2 = item.url
        else if (item.rank === 3) img3 = item.url
        else if (item.rank === 4) img4 = item.url
      });
      this.setState({
        img, img2, img3, img4
      });
    }
  }

  _handleMenu() {
    this.setState({ toggleMenu: !this.state.toggleMenu });
  }

  _handleLogout() {
    this.props.logoutUser();
  }

  _onHandleChange(event) {
    if (event.target.files) {
      this.setState({
        [event.target.name]: event.target.files[0],
      });
    } else {
      this.setState({
        [event.target.name]: event.target.value,
      });
    }
  }

  _onSubmit() {
    const data = {
      rank1: {},
      rank2: {},
      rank3: {},
      rank4: {},
    };

    if (this.state.photo) {
      data.rank1.file = this.state.photo
      data.rank1.oldImg = decodeURIComponent(this.state.img.substring(70, 95))
    } 
    if (this.state.photo2) {
      data.rank2.file = this.state.photo2
      data.rank2.oldImg = decodeURIComponent(this.state.img2.substring(70, 95))
    }
    if (this.state.photo3) {
      data.rank3.file = this.state.photo3
      data.rank3.oldImg = decodeURIComponent(this.state.img3.substring(70, 95))
    } 
    if (this.state.photo4) {
      data.rank4.file = this.state.photo4
      data.rank4.oldImg = decodeURIComponent(this.state.img4.substring(70, 95))
    } 

    // console.log(data)
    this.props.brandUpdatePromo(data);
  }

  render() {
    if (!this.props.user) return <div></div>;
    return (
      <div>
        <Header name={this.props.user} logout={() => this._handleLogout()} />
        <div className="admin-editbrand">
          <Nav active="product" />
          <div
            className={this.state.toggleMenu ? "content moveover" : "content"}
          >
            <div className="content-inner">
              <HamburgerMenu onClick={() => this._handleMenu()} />
              <div className="title">
                <h2>Promotion Banner: แก้ไข</h2>
              </div>
              <div className="info">
                <div className="adjust">
                  <form action="" className="photo">
                    <div className="brand-title" style={{ width: '250px' }}>
                      <p>Rank 1 (414x173px)</p>
                    </div>
                    <div className="filename">
                      <p>{this.state.photo.name}</p>
                    </div>
                    <div className="photo-input">
                      <input
                        id="photo"
                        type="file"
                        name="photo"
                        accept="image/*"
                        hidden
                        onChange={(event) => this._onHandleChange(event)}
                      />
                      <label htmlFor="photo">เลือกรูปภาพ</label>
                    </div>
                    <div className="oldphoto">
                      <img src={this.state.img} alt="brand" />
                    </div>
                  </form>

                  <form action="" className="photo" style={{ margin: '50px 0' }}>
                    <div className="brand-title" style={{ width: '250px' }}>
                      <p>Rank 2 (414x173px)</p>
                    </div>
                    <div className="filename">
                      <p>{this.state.photo2.name}</p>
                    </div>
                    <div className="photo-input">
                      <input
                        id="photo2"
                        type="file"
                        name="photo2"
                        accept="image/*"
                        hidden
                        onChange={(event) => this._onHandleChange(event)}
                      />
                      <label htmlFor="photo2">เลือกรูปภาพ</label>
                    </div>
                    <div className="oldphoto">
                      <img src={this.state.img2} alt="brand" />
                    </div>
                  </form>

                  <form action="" className="photo" style={{ margin: '50px 0' }}>
                    <div className="brand-title" style={{ width: '250px' }}>
                      <p>Rank 3 (414x173px)</p>
                    </div>
                    <div className="filename">
                      <p>{this.state.photo3.name}</p>
                    </div>
                    <div className="photo-input">
                      <input
                        id="photo3"
                        type="file"
                        name="photo3"
                        accept="image/*"
                        hidden
                        onChange={(event) => this._onHandleChange(event)}
                      />
                      <label htmlFor="photo3">เลือกรูปภาพ</label>
                    </div>
                    <div className="oldphoto">
                      <img src={this.state.img3} alt="brand" />
                    </div>
                  </form>

                  <form action="" className="photo" style={{ margin: '50px 0 15px' }}>
                    <div className="brand-title" style={{ width: '250px' }}>
                      <p>Rank 4 (414x173px)</p>
                    </div>
                    <div className="filename">
                      <p>{this.state.photo4.name}</p>
                    </div>
                    <div className="photo-input">
                      <input
                        id="photo4"
                        type="file"
                        name="photo4"
                        accept="image/*"
                        hidden
                        onChange={(event) => this._onHandleChange(event)}
                      />
                      <label htmlFor="photo4">เลือกรูปภาพ</label>
                    </div>
                    <div className="oldphoto">
                      <img src={this.state.img4} alt="brand" />
                    </div>
                  </form>

                  <div
                    className="action-button"
                    style={{ marginBottom: "20px" }}
                  >
                    {this.props.loading ? (
                      <div>
                        <p style={{ textAlign: "left" }}>Loading...</p>
                      </div>
                    ) : (
                      <div>
                        <Button type="primary" onClick={() => this._onSubmit()}>
                          บันทึก
                        </Button>
                        <Button onClick={() => window.history.back()}>
                          กลับ
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, brand }) => {
  return {
    user: auth.user,
    promoBrand: brand.promoBrand,
    loading: brand.loading,
  };
};

export default connect(mapStateToProps, {
  loginUserCheck,
  logoutUser,
  brandFetchPromo,
  brandUpdatePromo,
})(AdminProductPromotion);
